import Axios from 'axios';
import { API_URL } from '../../../../../constants/Constants';
import { ApiObjAdminPhoneNumberSource } from '../../../../object/admin/ApiObjAdminPhoneNumberSource';

export const api_admin_user_get_phone_number_sources = async (userId: number) : Promise<Array<ApiObjAdminPhoneNumberSource>> => {

    const url = API_URL+'/admin/user/'+userId+'/phone_number_source';
    const config = {
        'Access-Control-Allow-Origin': API_URL,
        withCredentials: true 
    };
    
    const resp = await Axios.get(
        url,
        config
    );
        
    const ret = [];
    for (const item of resp.data) {
        ret.push(new ApiObjAdminPhoneNumberSource(item));
    }
    return ret;
}
